/** Translates legacy POAM bookmarks to the canonical customer-facing Actions URL. */
export function legacyPoamRedirectTarget(location: Pick<Location, 'search' | 'hash'>): string {
  const searchParams = new URLSearchParams(location.search);
  const legacyActionId = searchParams.get('poamId');
  if (!searchParams.get('actionId') && legacyActionId) searchParams.set('actionId', legacyActionId);
  searchParams.delete('poamId');
  if (searchParams.get('action') === 'create-poam') searchParams.set('action', 'create-action');
  return `/actions${searchParams.size ? `?${searchParams.toString()}` : ''}${location.hash}`;
}
